/* FalcX purchase configurations (r6): Front pair, Rear pair, Full set.
   Listings show one card per configuration (snippets/falcx-config-card.liquid). Rear pair and Full set replace the
   factory rear coil springs, which only sedans have (product listings and /pages/fitment); since the r8 badge round a
   ute or wagon still sees and can buy them, with a "Sedans only" badge (below). On /collections/coilovers only the vehicle's series group shows until "Show every
   Falcon" is pressed. The product page gets a three-way choice (snippets/falcx-config-picker.liquid) that drives
   Horizon's own variant picker, so price, stock, add to cart and ?variant= stay Horizon's.
   Loaded after falcx-finder.js and before falcx-fitment.js (falcx-head), so cards are filtered before the lists are
   revealed and nothing jumps.
   r6 fitment pass: an in-development Rear pair (AU sedan rear coilovers, snippets/falcx-config-dev-card.liquid and the product page
   row) follows the same body rule, so a ute or wagon never sees it; on the product page it also needs the vehicle on
   show to be an AU (or none). The EA–AU front pair fits every EA–ED, EF–EL and AU body (owner, 5 Oct 2026), so the r6
   "text us before you order" note for EA–AU utes and wagons is gone; the tick comes from falcx.compatible_vehicles as everywhere else.
   r7: the product page choice answers at once from the page's own variant data (showNow), and heal() fixes Horizon's
   stale price ref that left $400.00 on screen after switching to the Full set straight after load.
   r8: the BA–BF and FG–FGX products have their own Rear pair variant again (a bundle of the one BA–FGX rear SKU), so the
   Rear pair switches in place like the other two.
   r8 badge round (owner, 6 Oct 2026: warn, don't block): every choice is always selectable and buyable, for every
   vehicle. A ute or wagon arriving on a product page without ?variant= still lands on the Front pair.
   r10 (owner, 7 Oct 2026: never hide the rear pair or full set, e.g. from someone who picked a wagon by mistake): Rear
   pair and Full set always carry a neutral "Sedans only" badge (product page rows and listing cards, in the markup,
   for every vehicle). Listing grids always show all three cards (the r8 "Also for sedans" tile is gone). With a ute or
   wagon on show and a sedan-only choice selected, the line under Add to cart reads "Sedans only. Your saved Falcon is a
   BA–BF wagon, which has leaf springs at the rear. Have a sedan? Change vehicle." Add to cart is never disabled.
   Photos follow the choice: each configuration's variants carry its own photo (Shopify variant media). A click swaps
   the gallery's first photo, its thumbnail, its zoom copy and the sticky bar's photo for the target's at once (same
   size, so nothing moves), then Horizon's own fetch replaces the gallery with the same markup. The other
   configurations' photos are fetched on idle or first touch of the choice, at the size the gallery uses. */
(function () {
  'use strict';
  var ORDER = ['front', 'rear', 'full'];
  var GEN = { 'ea-ed': 'ea-el', 'ef-el': 'ea-el', au: 'au', 'ba-bf': 'ba-bf', fg: 'fg-fgx', fgx: 'fg-fgx' };
  var BODY_NOTE = 'Utes and wagons: front pair only. They run leaf springs at the rear.';
  /* Finder series -> the generation key used by the products' chassis:* tags and the hubs. */
  function genOf(vehicle) { return vehicle && GEN[vehicle.series] || null; }
  function list(value) {
    if (Array.isArray(value)) return value.filter(function (x) { return typeof x === 'string' && x.trim(); });
    return String(value || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  /* Can this vehicle use this configuration at all? Only the body rule: rear pair and full set are sedans only. */
  function suits(config, vehicle) {
    if (!vehicle || config === 'front') return { ok: true, reason: '' };
    if (vehicle.body === 'sedan') return { ok: true, reason: '' };
    return { ok: false, reason: BODY_NOTE };
  }
  /* What the falcx.compatible_vehicles lists say about a card's variants: match (every variant lists the vehicle),
     unlisted (lists exist and none names it) or unknown (a variant has no list). Same keys as falcx-fitment.js. */
  function listed(data, vehicle) {
    if (!vehicle || !data) return 'unknown';
    var keys = [vehicle.key, vehicle.fitmentKey].filter(Boolean);
    var variants = data.variants || [];
    if (!variants.length) return 'unknown';
    var states = variants.map(function (variant) {
      var values = list(variant.vehicles).length ? list(variant.vehicles) : list(data.vehicles);
      if (!values.length) return 'unknown';
      return keys.some(function (key) { return values.indexOf(key) !== -1; }) ? 'match' : 'unlisted';
    });
    if (states.indexOf('unknown') !== -1) return 'unknown';
    if (states.indexOf('match') !== -1) return 'match';
    return 'unlisted';
  }
  /* The variant to select for a configuration: same spring rate as now if that exists, else the first one in stock,
     else the first one. */
  function pickVariant(variants, config, spring) {
    var group = (variants || []).filter(function (v) { return v.config === config; });
    if (!group.length) return null;
    return group.find(function (v) { return spring && v.spring === spring; }) ||
      group.find(function (v) { return v.available; }) || group[0];
  }
  /* An in-development configuration (product page row): shown with no vehicle on show, else only when the body rule
     allows it and the vehicle's generation is one it names (AU sedan rear: gens "au"). */
  function showDev(config, gens, vehicle) {
    if (!vehicle) return true;
    var names = list(gens);
    return suits(config, vehicle).ok && (!names.length || names.indexOf(genOf(vehicle)) !== -1);
  }
  function sortConfigs(items) {
    return items.slice().sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); });
  }
  /* r7: what a click on a row selects, worked out from the variant data already on the page (no request).
     from = configuration selected now, springNow = its spring rate, lastSpring = the front rate remembered before a
     Rear pair. Returns { target, remember } (remember = the rate to keep for coming back from a Rear pair). */
  function plan(variants, config, from, springNow, lastSpring) {
    var remember = lastSpring || null;
    var spring = springNow;
    if (from !== 'rear' && springNow) remember = springNow;
    else if (from === 'rear' && lastSpring) spring = lastSpring;
    return { target: pickVariant(variants, config, spring), remember: remember };
  }
  function norm(text) { return String(text == null ? '' : text).replace(/\s+/g, ' ').trim(); }
  /* r7 race fix. Horizon's <product-price> swaps its price for the new one through a ref it collected when it was
     connected (assets/product-price.js: refs.priceContainer.replaceWith(new)). Horizon only starts watching for that swap
     in requestIdleCallback (assets/component.js), so a second variant change before the browser's first idle period
     (straight after load, a busy phone, a background tab) replaced a detached node: the address bar and the cart form
     moved to the Full set while the page kept showing $400.00. heal() re-reads the refs of any such component (its own
     updatedCallback) when a change starts, so Horizon's swap lands on the element on the page. Returns how many it healed. */
  function heal(components) {
    var healed = 0;
    (components || []).forEach(function (el) {
      var box = el && el.refs && el.refs.priceContainer;
      if (box && box.isConnected) return;
      if (el && typeof el.updatedCallback === 'function') {
        try { el.updatedCallback(); healed++; } catch (e) { /* leave Horizon's state alone */ }
      }
    });
    return healed;
  }
  /* ---------- r8 badge round: warn, don't block ----------
     sedanOnly: a ute or wagon is on show, so Rear pair and Full set get the "Sedans only" badge. */
  var BADGE = 'Sedans only';
  function sedanOnly(vehicle) { return !!vehicle && !suits('full', vehicle).ok; }
  function badgeFor(config, vehicle) { return sedanOnly(vehicle) && config !== 'front' ? BADGE : ''; }
  /* r10 (owner, 7 Oct 2026: show every option, badge it, don't block). The line under Add to cart while a ute or wagon is
     on show and a sedan-only choice is selected: "Sedans only." (bold, in the markup) then why, then "Change vehicle".
     "Your saved Falcon" only for the remembered vehicle; one that is only on show (a link, a hub page) is "You're
     shopping for …". The series keeps its letters, the body is lower case: "a BA–BF wagon", "an FG ute" (an before a
     letter said with a vowel sound: A, E, F, H, I, L, M, N, O, R, S, X). */
  function vehicleNoun(vehicle) {
    var label = String(vehicle && vehicle.label || '').trim();
    var body = String(vehicle && vehicle.body || '').toLowerCase();
    var series = label.replace(/\s+(sedan|ute|wagon)$/i, '');
    var noun = series + (body ? ' ' + body : '');
    return (/^[AEFHILMNORSX]/.test(series) ? 'an ' : 'a ') + noun;
  }
  function bodyWhy(config, vehicle, mine) {
    if (!badgeFor(config, vehicle)) return '';
    return (mine ? 'Your saved Falcon is ' : 'You\'re shopping for ') + vehicleNoun(vehicle) + ', which has leaf springs at the rear. Have a sedan?';
  }
  function bodyLine(config, vehicle, mine) {
    var why = bodyWhy(config, vehicle, mine);
    return why ? BADGE + '. ' + why : '';
  }
  /* ---------- Photos ----------
     A photo is known by its CDN path after /files/ ("BA_Front_Pair.png?v=1788509524"), the same string inside every
     src and srcset Horizon prints for it, whatever the width. */
  function mediaKey(url) {
    var text = String(url || '');
    var at = text.indexOf('/files/');
    if (at === -1) return '';
    return text.slice(at + 7).replace(/[&?]width=\d+/g, '').replace(/[&?]height=\d+/g, '').split(' ')[0];
  }
  /* What to do with the gallery for a target photo: nothing (no photo, or already first), select the slide that already
     shows it (Horizon's "hide other variants' media" is off), or swap the first photo for it. */
  function swapPlan(slideKeys, toKey) {
    if (!toKey || !slideKeys || !slideKeys.length) return { action: 'none' };
    if (slideKeys[0] === toKey) return { action: 'first' };
    var at = slideKeys.indexOf(toKey);
    if (at > 0) return { action: 'select', index: at };
    return { action: 'swap', from: slideKeys[0] };
  }
  /* A /cart.js line that is a Rear pair or Full set (its Configuration option, or a coilover listing that is only a rear). */
  function sedanLine(item) {
    if (!item || String(item.product_type || '').toLowerCase() !== 'coilovers') return false;
    var opts = item.options_with_values || [];
    var cfg = opts.find(function (o) { return o && o.name === 'Configuration'; });
    if (cfg) return /^(rear pair|full set)$/i.test(String(cfg.value || '').trim());
    return /\brear\b/i.test(String(item.product_title || ''));
  }
  function swapText(text, from, to) { return text && from && text.indexOf(from) !== -1 ? text.split(from).join(to) : text; }
  var core = { genOf: genOf, sedanOnly: sedanOnly, badgeFor: badgeFor, bodyLine: bodyLine, bodyWhy: bodyWhy, vehicleNoun: vehicleNoun, mediaKey: mediaKey, swapPlan: swapPlan, swapText: swapText, sedanLine: sedanLine, BADGE: BADGE, suits: suits, listed: listed, showDev: showDev, pickVariant: pickVariant, sortConfigs: sortConfigs, plan: plan, heal: heal, norm: norm, ORDER: ORDER, BODY_NOTE: BODY_NOTE };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.FalcxConfig) { window.FalcxConfig.apply(); return; }

  function vehicle() {
    var api = window.FalcxVehicle;
    if (!api) return null;
    return api.getActive ? api.getActive() : api.getSaved ? api.getSaved() : null;
  }
  function parseJSON(text) {
    try { return JSON.parse(text || 'null'); } catch (e) { return null; }
  }
  function parse(script) { return script ? parseJSON(script.textContent) : null; }
  function setText(el, value) { if (el && el.textContent !== value) el.textContent = value; }
  var domReady = document.readyState === 'complete';
  document.addEventListener('DOMContentLoaded', function () { domReady = true; }, { once: true });
  function whenReady(fn) { if (domReady) fn(); else document.addEventListener('DOMContentLoaded', fn, { once: true }); }

  /* ---------- Listing cards and the series groups on /collections/coilovers ---------- */
  /* r10 (owner, 7 Oct 2026): every card shows for every vehicle, in the order Front pair, Rear pair, Full set. The Rear
     pair and Full set cards always carry the "Sedans only" badge (server markup, so nothing appears or moves); for a ute
     or wagon on show the card is marked data-sedan-only so the badge stands in for its "Not listed for …" line (CSS).
     The r8 "Also for sedans" tile is gone. The in-development AU rear still needs an AU sedan or no vehicle (showDev). */
  function applyCards() {
    var v = vehicle();
    var gen = genOf(v);
    document.querySelectorAll('[data-config-groups]').forEach(function (root) {
      var all = root.getAttribute('data-show-all') === 'true';
      root.querySelectorAll('[data-config-group]').forEach(function (group) {
        group.hidden = !!gen && !all && group.getAttribute('data-config-group') !== gen;
      });
      var button = root.querySelector('[data-config-showall]');
      if (button) {
        button.hidden = !gen;
        button.setAttribute('aria-expanded', String(all));
        setText(button, all ? 'Show only ' + (v ? v.label.replace(/\s+(sedan|ute|wagon)$/i, '') + ' Falcon' : 'my Falcon') : 'Show every Falcon');
      }
    });
    document.querySelectorAll('.falcx-pcard--config').forEach(function (card) {
      var show = true;
      if (card.hasAttribute('data-config-dev')) show = devShown(card, v);
      else if (badgeFor(card.getAttribute('data-config'), v)) card.setAttribute('data-sedan-only', '');
      else card.removeAttribute('data-sedan-only');
      card.hidden = !show;
      card.style.display = show ? '' : 'none';
    });
  }
  /* Kept so an older cached falcx-fitment.js calling it after its sort does nothing harmful. */
  function placeTiles() {}
  function devShown(el, v) {
    return showDev(el.getAttribute('data-config') || 'rear', el.getAttribute('data-gens'), v);
  }
  /* A notify form inside a closed <details> (in-development card or row): open it when the page comes back from a
     signup (success message or errors), so the visitor sees the result. */
  function openNotify() {
    var id = '';
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { id = ''; }
    var target = id ? document.getElementById(id) : null;
    var hits = [];
    if (target) hits.push(target);
    document.querySelectorAll('[data-config-notify] .falcx-form-error').forEach(function (el) { hits.push(el); });
    hits.forEach(function (el) {
      var box = el.closest && el.closest('details[data-config-notify]');
      if (box && !box.open) box.open = true;
    });
  }
  function onShowAll(event) {
    var button = event.target.closest && event.target.closest('[data-config-showall]');
    if (!button) return;
    var root = button.closest('[data-config-groups]');
    if (!root) return;
    root.setAttribute('data-show-all', String(root.getAttribute('data-show-all') !== 'true'));
    applyCards();
  }

  /* ---------- Product page: the three-way choice ---------- */
  function horizonPicker(root) {
    var scope = root.closest('.product-details') || root.closest('product-component') || document;
    return scope.querySelector('variant-picker');
  }
  function radios(picker, name) {
    return picker ? Array.prototype.filter.call(picker.querySelectorAll('input[type="radio"]'), function (i) { return i.getAttribute('data-option-name') === name; }) : [];
  }
  function checkedValue(picker, name) {
    var on = radios(picker, name).find(function (i) { return i.checked; });
    return on ? on.value : null;
  }
  function currentConfig(root, data) {
    var picker = horizonPicker(root);
    var value = data && data.configOption ? checkedValue(picker, data.configOption) : null;
    if (value) {
      var hit = (data.variants || []).find(function (v) { return v.configValue === value; });
      if (hit) return hit.config;
    }
    return root.getAttribute('data-current');
  }
  function isMine(v) {
    var api = window.FalcxVehicle;
    return !!(v && api && (api.isMine ? api.isMine(v) : true));
  }
  function ownFront(root) { return !!root.querySelector('.falcx-config__opt[data-config="front"]:not([data-other])'); }
  function hasRearChoice(root) { return !!root.querySelector('.falcx-config__opt:not([data-config="front"])'); }
  function scopeOf(root) { return root.closest('.shopify-section') || document; }
  function refreshPicker(root, chosen) {
    var data = parse(root.querySelector('[data-config-data]')) || {};
    var v = vehicle();
    var gen = genOf(v);
    var current = chosen || currentConfig(root, data);
    if (current) root.setAttribute('data-current', current);
    var only = sedanOnly(v) && hasRearChoice(root);
    root.querySelectorAll('.falcx-config__opt').forEach(function (opt) {
      var config = opt.getAttribute('data-config');
      var gens = list(opt.getAttribute('data-gens'));
      /* Links to the matching series product (on the BA–FGX rear page): only the vehicle's series when it is one of them. */
      var other = opt.hasAttribute('data-other');
      var li = opt.closest('li') || opt;
      if (other) {
        var mine = root.querySelectorAll('.falcx-config__opt[data-other][data-config="' + config + '"]');
        var anyMatch = gen && Array.prototype.some.call(mine, function (o) { return list(o.getAttribute('data-gens')).indexOf(gen) !== -1; });
        li.hidden = !!anyMatch && gens.indexOf(gen) === -1;
      }
      var isCurrent = !other && config === current;
      if (isCurrent) opt.setAttribute('aria-current', 'true'); else opt.removeAttribute('aria-current');
    });
    root.querySelectorAll('[data-config-dev]').forEach(function (row) {
      var show = devShown(row, v);
      row.hidden = !show;
    });
    if (only) {
      root.setAttribute('data-body', v.body);
      root.setAttribute('data-vwhy', bodyWhy('full', v, isMine(v)));
    } else {
      root.removeAttribute('data-body');
      root.removeAttribute('data-vwhy');
    }
    /* The general sedans-only note gives way to the line under Add to cart (the badges are always there). */
    var note = root.querySelector('[data-config-body-note]');
    if (note) { note.hidden = only; note.classList.remove('is-active'); }
    var why = only ? bodyWhy(current, v, isMine(v)) : '';
    scopeOf(root).querySelectorAll('[data-config-bodyline]').forEach(function (line) {
      if (why) setText(line.querySelector('[data-bodyline-text]'), why);
      line.hidden = !why;
    });
    return data;
  }
  /* ---------- Photos: the chosen configuration's photo at once ---------- */
  function slideImages(gallery) {
    return Array.prototype.map.call(gallery.querySelectorAll('slideshow-slide'), function (slide) { return slide.querySelector('img'); });
  }
  /* Swap the gallery's first photo (slide, thumbnail, zoom copy, sticky bar) for the target's. Every configuration's
     gallery is the same apart from that first photo (Horizon lists the selected variant's photo first and, with "hide
     other variants' media", leaves the others out), and the photos are the same size (square gallery), so this is what
     Horizon's answer will show, with nothing moving. Horizon's fetch then replaces the gallery with its own copy. */
  function swapGallery(root, target) {
    var to = target && target.media;
    var scope = scopeOf(root);
    var gallery = scope.querySelector('media-gallery');
    if (!to || !gallery) return false;
    var images = slideImages(gallery);
    var step = swapPlan(images.map(function (img) { return img ? mediaKey(img.getAttribute('src')) : ''; }), to);
    if (step.action === 'none') return false;
    if (step.action === 'swap') {
      var oldAlt = images[0] ? images[0].getAttribute('alt') : null;
      var newAlt = target.mediaAlt == null ? null : String(target.mediaAlt);
      scope.querySelectorAll('img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        if (src.indexOf(step.from) === -1) return;
        img.setAttribute('src', swapText(src, step.from, to));
        var set = img.getAttribute('srcset');
        if (set) img.setAttribute('srcset', swapText(set, step.from, to));
        if (newAlt !== null) img.setAttribute('alt', newAlt);
      });
      if (oldAlt && newAlt) {
        gallery.querySelectorAll('[aria-label]').forEach(function (el) {
          var label = el.getAttribute('aria-label');
          if (label && label.indexOf(oldAlt) !== -1) el.setAttribute('aria-label', swapText(label, oldAlt, newAlt));
        });
      }
    }
    root.setAttribute('data-media', to);
    var index = step.action === 'select' ? step.index : 0;
    var show = gallery.slideshow || gallery.querySelector('slideshow-component');
    try { if (show && typeof show.select === 'function' && show.current !== index) show.select(index, undefined, { animate: false }); } catch (e) { /* Horizon's answer shows it anyway */ }
    return true;
  }
  /* Fetch the other configurations' photos at the size the gallery would pick (same srcset and sizes), so the swap is
     instant on a phone. Once per page, at the first touch or focus of the choice. */
  var warmed = [];
  function warmPhotos(root) {
    if (!root || root.hasAttribute('data-photos-warm')) return;
    root.setAttribute('data-photos-warm', '');
    var data = parse(root.querySelector('[data-config-data]')) || {};
    var gallery = scopeOf(root).querySelector('media-gallery');
    var first = gallery && slideImages(gallery)[0];
    if (!first) return;
    var from = mediaKey(first.getAttribute('src'));
    var models = [first];
    var thumb = gallery.querySelector('slideshow-controls img');
    /* Thumbnails only where they show (desktop); the phone has dots. */
    if (thumb && thumb.offsetParent !== null && mediaKey(thumb.getAttribute('src')) === from) models.push(thumb);
    var done = {};
    done[from] = true;
    (data.variants || []).forEach(function (variant) {
      if (!variant.media || done[variant.media]) return;
      done[variant.media] = true;
      models.forEach(function (model) {
        var img = new Image();
        img.decoding = 'async';
        var sizes = model.getAttribute('sizes');
        if (sizes && sizes.indexOf('auto') === -1) img.sizes = sizes;
        var set = model.getAttribute('srcset');
        if (set) img.srcset = swapText(set, from, variant.media);
        img.src = swapText(model.getAttribute('src'), from, variant.media);
        warmed.push(img);
      });
    });
  }
  /* ---------- r7: instant choice ----------
     A click shows the result at once from the variant data on the page (row, price, cart form, stock line, fitment
     tick, photo, address), then lets Horizon's picker fetch and morph as before, so its add-to-cart form, sticky bar and
     gallery end up in the same state underneath. Nothing navigates and nothing scrolls. */
  function prices(scope) {
    return Array.prototype.filter.call(scope.querySelectorAll('product-price'), function (el) {
      return !el.closest('product-card, sticky-add-to-cart, quick-add-dialog');
    });
  }
  function setAddress(id) {
    if (!id || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get('variant') === String(id)) return;
    url.searchParams.set('variant', String(id));
    window.history.replaceState(window.history.state, '', url.toString());
  }
  function showNow(root, data, target) {
    var scope = scopeOf(root);
    var id = String(target.id);
    /* Price: only the plain one-price case Horizon renders for these products ($799.00); anything else (sale, unit
       price) is left to Horizon's own update. */
    if (target.money) {
      prices(scope).forEach(function (el) {
        var box = el.querySelector('[ref="priceContainer"]');
        var only = box && box.children.length === 1 && box.children[0].matches('.price') ? box.children[0] : null;
        if (only && target.compare == null) setText(only, target.money);
      });
    }
    /* The cart form adds the chosen variant even if someone presses Add to cart before Horizon has answered. */
    scope.querySelectorAll('product-form-component').forEach(function (form) {
      if (data.productId && form.dataset.productId && String(form.dataset.productId) !== String(data.productId)) return;
      var input = form.querySelector('input[name="id"]');
      if (input && input.value !== id) input.value = id;
      if (!target.available) form.querySelectorAll('[ref="addToCartButton"]').forEach(function (b) { b.disabled = true; });
    });
    setAddress(id);
    swapGallery(root, target);
    if (window.FalcxFitment && window.FalcxFitment.expect) window.FalcxFitment.expect(data.productId, id);
    if (window.FalcxStock && window.FalcxStock.update) window.FalcxStock.update();
  }
  function select(root, config) {
    var data = parse(root.querySelector('[data-config-data]')) || {};
    var picker = horizonPicker(root);
    if (!picker || !data.configOption) return false;
    var springNow = data.springOption ? checkedValue(picker, data.springOption) : null;
    var from = currentConfig(root, data);
    var choice = plan(data.variants, config, from, springNow, root.getAttribute('data-last-spring'));
    var target = choice.target;
    if (!target) return false;
    if (choice.remember) root.setAttribute('data-last-spring', choice.remember);
    var configInput = radios(picker, data.configOption).find(function (i) { return i.value === target.configValue; });
    if (!configInput) return false;
    if (data.springOption && target.spring) {
      var spring = radios(picker, data.springOption).find(function (i) { return i.value === target.spring; });
      /* Set quietly: Horizon builds its request from every checked option when the configuration changes. */
      if (spring && !spring.checked) spring.checked = true;
    }
    root.setAttribute('data-current', config);
    root.setAttribute('data-pending-variant', String(target.id));
    refreshPicker(root, config);
    showNow(root, data, target);
    var status = root.querySelector('[data-config-status]');
    var name = root.querySelector('.falcx-config__opt[data-config="' + config + '"] .falcx-config__name');
    var v = vehicle();
    var why = sedanOnly(v) ? bodyLine(config, v, isMine(v)) : '';
    setText(status, (name ? name.textContent : config) + ' selected' + (target.money ? ', ' + target.money : '') + '.' + (why ? ' ' + why : ''));
    heal(prices(scopeOf(root)));
    if (!configInput.checked) {
      /* Horizon puts the clicked radio's data-variant-id in the address (after a yield, so after anything done here); it
         was rendered for the old spring rate (Front pair after a Rear pair: Standard; Rear pair with 18 kg checked: none).
         Give it the exact variant chosen here. Its request uses the checked option values, not this. */
      configInput.setAttribute('data-variant-id', String(target.id));
      configInput.click();
      /* Horizon writes the variant of the radio it rendered into the address after a yield; the variant chosen here
         is the exact one (spring rate included), so put it back if Horizon's differs. */
      setTimeout(function () { if (root.getAttribute('data-pending-variant') === String(target.id)) setAddress(target.id); }, 0);
    } else {
      root.removeAttribute('data-pending-variant');
    }
    return true;
  }
  function onPickerClick(event) {
    var opt = event.target.closest && event.target.closest('.falcx-config__opt');
    if (!opt) return;
    var root = opt.closest('[data-falcx-config-picker]');
    if (!root) return;
    if (opt.hasAttribute('data-other')) return;
    if (opt.getAttribute('aria-current') === 'true') { event.preventDefault(); return; }
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; /* new tab/window: let the link work */
    if (select(root, opt.getAttribute('data-config'))) event.preventDefault();
  }
  /* The Front pair / Full set rows on the BA–FGX rear page (and the fallback Rear pair row) are another listing, so
     they navigate. Fetch that page as soon as the visitor shows intent, so the navigation is quick. Any touch of the
     choice also fetches the other configurations' photos. */
  var prefetched = {};
  function onIntent(event) {
    var target = event.target;
    var root = target && target.closest && target.closest('[data-falcx-config-picker]');
    if (root) warmPhotos(root);
    var opt = target && target.closest && target.closest('.falcx-config__opt[data-other][href]');
    if (!opt) return;
    var href = opt.getAttribute('href');
    if (!href || prefetched[href]) return;
    prefetched[href] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'document';
    document.head.appendChild(link);
  }
  /* Horizon fires shopify:product:select when it starts fetching; the promise settles once it has morphed. */
  function onProductSelect(event) {
    var promise = event && event.promise;
    var source = event && event.target instanceof Element ? event.target : null;
    if (source && source.closest('product-card, quick-add-dialog')) return;
    var scope = source ? (source.closest('.shopify-section') || document) : document;
    /* Root fix for the stale price (see heal()): before Horizon's listeners run their swap. */
    heal(prices(scope));
    var roots = scope.querySelectorAll('[data-falcx-config-picker]');
    Promise.resolve(promise).then(function (result) {
      var detail = result && result.detail;
      var id = detail && detail.resource && detail.resource.id;
      /* Belt and braces: whatever happened to Horizon's swap, the price on the page matches the variant it fetched. */
      if (detail && detail.html) {
        prices(scope).forEach(function (el) {
          var block = el.getAttribute('data-block-id');
          var fresh = block && detail.html.querySelector('product-price[data-block-id="' + block + '"] [ref="priceContainer"]');
          var live = el.querySelector('[ref="priceContainer"]');
          if (!fresh || !live || norm(fresh.textContent) === norm(live.textContent)) return;
          live.replaceWith(document.importNode(fresh, true));
          if (typeof el.updatedCallback === 'function') { try { el.updatedCallback(); } catch (e) { /* ignore */ } }
        });
      }
      roots.forEach(function (root) {
        root.removeAttribute('data-pending-variant');
        refreshPicker(root);
        /* Horizon's gallery now lists the fetched variant's photo first. */
        var gallery = scopeOf(root).querySelector('media-gallery');
        var first = gallery && slideImages(gallery)[0];
        if (first) root.setAttribute('data-media', mediaKey(first.getAttribute('src')));
      });
      if (id && roots.length) setAddress(id);
    }, function () { roots.forEach(function (root) { refreshPicker(root); }); });
  }
  /* A ute or wagon that arrives without ?variant= (the first variant is the Full set) lands on the Front pair: helpful,
     not a restriction (any choice stays one tap away). Only on arrival: a vehicle change later leaves the choice alone. */
  var arrivedWithVariant = new URLSearchParams(window.location.search).has('variant');
  function landOnFront(root) {
    if (arrivedWithVariant || root.hasAttribute('data-landed')) return;
    root.setAttribute('data-landed', '');
    if (!sedanOnly(vehicle()) || !ownFront(root) || !hasRearChoice(root)) return;
    if (currentConfig(root, parse(root.querySelector('[data-config-data]')) || {}) === 'front') return;
    var go = function () {
      if (!sedanOnly(vehicle())) return;
      if (currentConfig(root, parse(root.querySelector('[data-config-data]')) || {}) !== 'front') select(root, 'front');
    };
    /* After DOMContentLoaded: every deferred FalcX script (falcx-fitment.js) is listening by then. */
    whenReady(function () {
      if (window.customElements && window.customElements.whenDefined) window.customElements.whenDefined('variant-picker').then(go);
      else go();
    });
  }
  function applyPickers() {
    document.querySelectorAll('[data-falcx-config-picker]').forEach(function (root) { refreshPicker(root); landOnFront(root); });
  }

  /* ---------- Cart: the same quiet badge on a Rear pair or Full set line while a ute or wagon is remembered ----------
     Horizon's cart lines (cart page and drawer) are tr[data-key]; the Rear pair and Full set are bundles, whose lines
     show their parts instead of the option, so which line is which comes from /cart.js. Nothing is blocked. */
  var cartLines = null;
  var cartLoading = null;
  var cartAskedFor = '';
  function loadCart(force) {
    if (cartLoading && !force) return cartLoading;
    cartLoading = fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartLines = {};
        (cart.items || []).forEach(function (item) { cartLines[item.key] = sedanLine(item); });
        return cartLines;
      }, function () { cartLines = cartLines || {}; return cartLines; });
    return cartLoading;
  }
  function paintCart() {
    var saved = window.FalcxVehicle && window.FalcxVehicle.getSaved ? window.FalcxVehicle.getSaved() : null;
    var on = sedanOnly(saved);
    var rows = document.querySelectorAll('tr.cart-items__table-row[data-key]');
    if (!rows.length) return;
    var keys = Array.prototype.map.call(rows, function (row) { return row.getAttribute('data-key'); }).join('|');
    var missing = !cartLines || keys.split('|').some(function (key) { return !(key in cartLines); });
    if (on && missing && cartAskedFor !== keys) {
      cartAskedFor = keys; /* once per set of lines, so a line /cart.js doesn't list can't loop */
      loadCart(true).then(paintCart);
      if (!cartLines) return;
    }
    rows.forEach(function (row) {
      var want = on && !!cartLines && cartLines[row.getAttribute('data-key')] === true;
      var badge = row.querySelector('[data-falcx-cartbadge]');
      if (want && !badge) {
        var host = row.querySelector('.cart-items__product-info') || row.querySelector('.cart-items__details');
        if (!host) return;
        badge = document.createElement('span');
        badge.className = 'falcx-config__badge falcx-cartbadge';
        badge.setAttribute('data-falcx-cartbadge', '');
        badge.textContent = BADGE;
        host.appendChild(badge);
      } else if (!want && badge) badge.remove();
    });
  }
  var cartTimer = 0;
  function watchCart() {
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.hasAttribute('data-falcx-watched') || !window.MutationObserver) return;
      el.setAttribute('data-falcx-watched', '');
      new MutationObserver(function () { clearTimeout(cartTimer); cartTimer = setTimeout(paintCart, 60); }).observe(el, { childList: true, subtree: true });
    });
    paintCart();
  }

  function apply() { applyCards(); applyPickers(); watchCart(); }

  window.FalcxConfig = { apply: apply, placeTiles: placeTiles, genOf: genOf, suits: suits, listed: listed, pickVariant: pickVariant, devShown: devShown, sedanOnly: sedanOnly, badgeFor: badgeFor, swapGallery: swapGallery };
  document.addEventListener('click', onShowAll);
  document.addEventListener('click', onPickerClick);
  document.addEventListener('pointerenter', onIntent, true);
  document.addEventListener('pointerdown', onIntent, true);
  document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
  document.addEventListener('focusin', onIntent);
  document.addEventListener('falcx:vehicle-change', apply);
  document.addEventListener('falcx:browsing-change', apply);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:product:select', onProductSelect);
  document.addEventListener('shopify:section:load', openNotify);
  document.addEventListener('cart:update', function () { loadCart(true).then(function () { setTimeout(watchCart, 0); }); });
  window.addEventListener('hashchange', openNotify);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); openNotify(); }, { once: true });
  else { apply(); openNotify(); }
})();
